import React from "react";

export default function SQL_EXISTS() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_EXISTS</h1>
      <p>This is the SQL_EXISTS component generated from the SQL JSON.</p>
    </div>
  );
}
